const TWILIO_VIDEO_STATE_EVENTS = [
  'started',
  'enabled',
  'disabled',
  'switchedOn',
  'switchedOff',
  'dimensionsChanged',
];

const MEDIA_STREAM_STATE_EVENTS = ['mute', 'unmute', 'ended'];

export const isRemoteVideoTrackPlayable = track => {
  if (!track || track.kind !== 'video') return false;
  if (track.isStarted !== true) return false;
  if (track.isEnabled === false || track.isSwitchedOff === true) return false;

  const { width, height } = track.dimensions ?? {};
  if (!(width > 0 && height > 0)) return false;

  const mediaStreamTrack = track.mediaStreamTrack;
  if (!mediaStreamTrack) return false;
  if (
    mediaStreamTrack.enabled === false ||
    mediaStreamTrack.muted === true ||
    mediaStreamTrack.readyState === 'ended'
  ) {
    return false;
  }

  return true;
};

export const subscribeToRemoteVideoTrackState = (track, onChange) => {
  TWILIO_VIDEO_STATE_EVENTS.forEach(event => track.on?.(event, onChange));

  const mediaStreamTrack = track.mediaStreamTrack;
  MEDIA_STREAM_STATE_EVENTS.forEach(event =>
    mediaStreamTrack?.addEventListener?.(event, onChange)
  );

  return () => {
    TWILIO_VIDEO_STATE_EVENTS.forEach(event => track.off?.(event, onChange));
    MEDIA_STREAM_STATE_EVENTS.forEach(event =>
      mediaStreamTrack?.removeEventListener?.(event, onChange)
    );
  };
};
